import { PORTAL_NAV, defaultSub } from '../constants/portals';
import { PORTAL_TAB_MAP } from '../portalConfig';

// Resolve existing registry destinations for the compact navigation drawer.
// Permissions remain owned by the drawer and each destination's route gate.
export function resolvePortalNavigation(portalId, subKey) {
  const portal = PORTAL_NAV.find(p => p.key === portalId && !p.soon);
  if (!portal) return null;
  const sub = subKey ? portal.subsections?.find(s => s.key === subKey) : defaultSub(portal);
  if (subKey && !sub) return null;
  return { tab: sub?.tab || PORTAL_TAB_MAP[portalId] || portalId,
    devView: sub?.devView, projectsView: sub?.projectsView || 'selection',
    salesView: sub?.salesView };
}
